"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsLayerId = void 0;
exports.useReports = useReports;
var _colors = require("@mui/material/colors");
var _maplibreGl = require("maplibre-gl");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _contributionClosedIcon = _interopRequireDefault(require("../../assets/images/report/contribution-closed-icon.svg"));
var _contributionOpenIcon = _interopRequireDefault(require("../../assets/images/report/contribution-open-icon.svg"));
var _reportPopup = require("../../components/map/report-popup");
var _layers = require("./layers");
var _popup = require("./popup");
var _source = require("./source");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const sourceId = 'reports';
const reportsLayerId = exports.reportsLayerId = 'reports';
const asMarkerMinZoom = 14;
function useReports(map, theme, {
  onDetailsClick
} = {}) {
  const initialized = (0, _react.useRef)(false);
  const markers = (0, _react.useRef)({});
  const selectedReportId = (0, _react.useRef)(null);
  const {
    addGeoJSONSource,
    updateGeoJSONSource,
    clearGeoJSONSource
  } = (0, _source.useSource)(map, sourceId);
  const {
    addCircleLayer
  } = (0, _layers.useLayers)(map);
  const {
    centerPopup
  } = (0, _popup.usePopup)(map);
  function init() {
    if (!map || initialized.current) return;
    addGeoJSONSource();
    addCircleLayer(reportsLayerId, sourceId, {
      'circle-radius': ['case', ['boolean', ['feature-state', 'hover'], false], 10, 5],
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': '#fff'
    });
    map.on('mouseenter', reportsLayerId, event => {
      if (event.defaultPrevented) return;
      event.originalEvent.preventDefault();
      event.preventDefault();
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', reportsLayerId, () => {
      map.getCanvas().style.cursor = '';
    });
    map.on('click', reportsLayerId, event => {
      if (event.originalEvent.defaultPrevented) return;
      event.originalEvent.preventDefault();
      const {
        features
      } = event;
      if (features && features.length > 0) {
        const {
          id,
          geometry
        } = features[0];
        if (typeof id === 'number') selectedReportId.current = id;
        if (geometry.type === 'Point') {
          const {
            coordinates: [lng, lat]
          } = geometry;
          map.flyTo({
            center: {
              lat,
              lng
            },
            zoom: asMarkerMinZoom
          });
        }
      }
    });
    initialized.current = true;
  }
  function openReportPopup(report) {
    closePrevSelectedPoiPopup();
    const {
      id,
      geoPoint: {
        coordinates: [lng, lat]
      }
    } = report;
    const selectedMarker = markers.current[id];
    if (!selectedMarker || selectedMarker.marker.getPopup().isOpen()) return;
    selectedMarker.marker.togglePopup();
    const ele = document.getElementById(`report-${report.id}-popup`);
    if (ele) {
      const container = (0, _client.createRoot)(ele);
      container.render(/*#__PURE__*/_react.default.createElement(_reportPopup.ReportPopup, {
        onClose: () => {
          if (selectedMarker.marker.getPopup().isOpen()) selectedMarker.marker.togglePopup();
          selectedReportId.current = null;
          if (container) container.unmount();
        },
        onDetailsClick: onDetailsClick ? () => onDetailsClick(id) : undefined,
        report: report,
        sourcesMap: undefined,
        theme: theme
      }));
    }
    centerPopup({
      lat,
      lng
    }, selectedMarker.marker.getPopup(), {
      height: 200
    });
  }
  function closePrevSelectedPoiPopup() {
    Object.values(markers.current).forEach(({
      id,
      marker
    }) => {
      if (id !== selectedReportId.current && marker.getPopup().isOpen()) marker.togglePopup();
    });
  }
  function addMarker(report, {
    selectable
  } = {}) {
    if (!map || markers.current[report.id]) return;
    const {
      id,
      geoPoint: {
        coordinates: [lng, lat]
      },
      status
    } = report;
    const element = document.createElement('div');
    element.style.border = '2px solid #fff';
    element.style.borderRadius = '50%';
    element.style.backgroundImage = status === 'OPEN' ? `url(${_contributionOpenIcon.default})` : `url(${_contributionClosedIcon.default})`;
    element.style.backgroundPosition = 'center';
    element.style.backgroundRepeat = 'no-repeat';
    element.style.backgroundSize = '20px';
    element.style.width = '16px';
    element.style.height = '16px';
    element.style.cursor = selectable ? 'pointer' : 'auto';
    element.addEventListener('click', event => {
      event.stopPropagation();
      if (selectable && report) {
        selectedReportId.current = report.id;
        openReportPopup(report);
      }
    });
    const marker = new _maplibreGl.Marker({
      element
    }).setLngLat({
      lat,
      lng
    }).setPopup(new _maplibreGl.Popup({
      maxWidth: '350px',
      closeButton: false,
      closeOnClick: false,
      className: 'map-custom-popup',
      offset: 6
    }).setHTML(`<div id="report-${id}-popup"></div>`)).addTo(map);
    if (id) markers.current[id] = {
      id,
      marker
    };
  }
  function update(reports) {
    if (!map) return;
    if (map.getZoom() >= asMarkerMinZoom) {
      updateGeoJSONSource({
        type: 'FeatureCollection',
        features: []
      });
      reports.forEach(report => addMarker(report, {
        selectable: true
      }));
      const selectedReport = reports.find(({
        id
      }) => id === selectedReportId.current);
      if (selectedReport) openReportPopup(selectedReport);
    } else {
      Object.values(markers.current).forEach(({
        id,
        marker
      }) => {
        marker.remove();
        delete markers.current[id];
      });
      selectedReportId.current = null;
      updateGeoJSONSource({
        type: 'FeatureCollection',
        features: reports.map(({
          id,
          geoPoint,
          status
        }) => {
          return {
            id,
            type: 'Feature',
            geometry: geoPoint,
            properties: {
              color: status === 'OPEN' ? _colors.red[500] : _colors.green[500]
            }
          };
        })
      });
    }
  }
  function select(report) {
    if (!map) return;
    const {
      geoPoint: {
        coordinates: [lng, lat]
      }
    } = report;
    addMarker(report);
    map.flyTo({
      center: {
        lat,
        lng
      },
      zoom: 14
    });
  }
  function clear() {
    Object.values(markers.current).forEach(({
      id,
      marker
    }) => {
      marker.remove();
      delete markers.current[id];
    });
    selectedReportId.current = null;
    clearGeoJSONSource();
  }
  return {
    initialized: initialized.current,
    init,
    update,
    select,
    clear
  };
}